import { PpHttpConfig } from '@penpencil/common';
import tinymce from 'tinymce';

let config: PpHttpConfig;
export function setConfigForMetaProps(inputConfig: PpHttpConfig) {
  config = inputConfig;
}

export const HTML_IMG_TAG_REMOVAL_PATTERN = /<img[^>]*>/g;

export const getS3SecuredUrl = (file: any) => {
  return `${config.baseUrl}/v3/admin/files/s3-signed-url?type=ADMIN&name=${
    file?.name
  }&extension=${(file.name || '').split('.').pop()}&contentType=${file?.type}`;
};

export function file_picker_callback(callback: any, value: any, meta: any) {
  const input = document.createElement('input');
  input.setAttribute('type', 'file');
  input.setAttribute('accept', 'image/*');

  /*
    Note: In modern browsers input[type="file"] is functional without
    even adding it to the DOM, but that might not be the case in some older
    or quirky browsers like IE, so you might want to add it to the DOM
    just in case, and visually hide it. And do not forget do remove it
    once you do not need it anymore.
  */

  if (meta.filetype === 'image') {
    input.click();

    input.onchange = function () {
      const file = input?.files && input.files[0];

      const reader = new FileReader();
      if (file) {
        reader.onload = function () {
          /*
            Note: Now we need to register the blob in TinyMCEs image blob
            registry. In the next release this part hopefully won't be
            necessary, as we are looking to handle it internally.
          */
          const id = 'blobid' + new Date().getTime();
          const blobCache = tinymce.activeEditor?.editorUpload.blobCache;
          if (typeof reader.result === 'string') {
            const url: string = getS3SecuredUrl(file);
            const xhttp = new XMLHttpRequest();
            xhttp.open('GET', url, true);

            const formData = new FormData();
            formData.append('file', file);

            try {
              // xhttp.setRequestHeader('Content-Type', 'multipart/form-data');
              xhttp.setRequestHeader('Accept', '*!/!*');
              xhttp.setRequestHeader(
                'Authorization',
                'Bearer ' + localStorage.getItem('pp-token'),
              );

              xhttp.send(formData);
              // @ts-ignore
              document.getElementsByClassName(
                'tox-dialog__footer-end',
                // @ts-ignore
              )?.[0]?.childNodes?.[1]?.disabled = true;
              xhttp.onreadystatechange = async function (e) {
                // @ts-ignore
                document.getElementsByClassName(
                  'tox-dialog__footer-end',
                  // @ts-ignore
                )?.[0]?.childNodes?.[1]?.disabled = false;
                if (this.readyState === 4) {
                  if (this.status === 200) {
                    const response = JSON.parse(this.responseText).data;
                    const uploadResponse = await uploadSignedURLJSON(
                      response,
                      file,
                    );

                    if (uploadResponse?.ok) {
                      response['fullUrl'] = response.baseUrl + response.key;
                    }

                    const blobInfo = blobCache!.create(
                      id,
                      file,
                      response.baseUrl + response.key,
                    );
                    blobCache!.add(blobInfo);

                    callback(response.baseUrl + response.key, {
                      title: response.name,
                    });
                  } else {
                    const error = JSON.parse(this.responseText).error;
                    const errorMessage = JSON.parse(this.responseText).message;

                    if (errorMessage === 'Unauthorized') {
                      let event = new CustomEvent('USER_UNAUTHORIZED', {
                        detail: errorMessage,
                      });
                      window.dispatchEvent(event);
                    }
                    callback('', {
                      alt: 'Error: ' + error.message || 'There were some error',
                    });
                  }
                }
              };
            } catch (e) {}
          }
        };
        reader.readAsDataURL(file);
      }
    };
  }
}

export function paste_preprocess(editor: any, args: any) {
  args.content = args.content.replace(HTML_IMG_TAG_REMOVAL_PATTERN, '');
}

export const EDITOR_PROPS = {
  base_url: '/tinymce', // Root for resources
  height: 200,
  suffix: '.min', // Suffix to use when loading resources
  paste_data_images: false,
  paste_block_drop: true,
  // Add wiris plugin
  external_plugins: {
    tiny_mce_wiris: `${window.location.href}/node_modules/@wiris/mathtype-tinymce5/plugin.min.js`,
  },
  htmlAllowedTags: ['.*'],
  htmlAllowedAttrs: ['.*'],
  valid_children: '+body[style]',
  force_br_newlines: false,
  force_p_newlines: false,
  // This option allows us to introduce mathml formulas
  extended_valid_elements: '*[.*]',
  // We recommend to set 'draggable_modal' to true to avoid overlapping issues
  // with the different UI modal dialog windows implementations between core and third-party plugins on TinyMCE.
  // @see: https://github.com/wiris/html-integrations/issues/134#issuecomment-905448642
  draggable_modal: true,
  plugins: [
    'image',
    'link',
    'preview',
    'paste',
    'code',
    'help',
    'wordcount',
    'imagetools',
    'autoresize',
    'lists',
    'table',
    'media',
    'charmap',
    'advlist',
    'fullpage',
    'emoticons',
  ],
  table_toolbar:
    'tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
  toolbar:
    'styleselect' +
    ' | ' +
    'link table image media charmap' +
    ' | ' +
    'undo redo' +
    ' | ' +
    'bold italic underline strikethrough forecolor backcolor' +
    ' | ' +
    'subscript superscript' +
    ' | ' +
    'code' +
    ' | ' +
    'emoticons' +
    ' | ' +
    'removeformat' +
    ' | ' +
    'preview' +
    ' | ' +
    'alignleft aligncenter alignright alignjustify' +
    ' | ' +
    'numlist bullist outdent indent' +
    ' | ' +
    'tiny_mce_wiris_formulaEditor tiny_mce_wiris_formulaEditorChemistry',
  paste_preprocess,
  /* enable title field in the Image dialog*/
  image_title: true,
  /* enable automatic uploads of images represented by blob or data URIs*/
  automatic_uploads: true,
  file_picker_types: 'image',
  /* and here's our custom image picker*/
  file_picker_callback,
  // Handle events.

  setup(editor: any) {
    // Launch on init event.
    editor.on('init', () => {
      // Get and set the editor and wiris versions in this order.
      // Generic.setEditorAndWirisVersion(`${(window as any).tinymce.majorVersion}.${(window as any).tinymce.minorVersion}`, (window as any).WirisPlugin.currentInstance.version);   //eslint-disable-line
    });
  },
};

export async function uploadSignedURLJSON(data: any, file: File): Promise<any> {
  return await fetch(data?.uploadUrl, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': file.type,
    },
  });
}
